var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "login-container bgImg content"
  }, [_c("div", {
    staticClass: "layout"
  }, [_c("div", {
    staticClass: "titleBox"
  }, [_c("a-button", {
    staticClass: "back",
    attrs: {
      type: "link"
    },
    on: {
      click: function ($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("返回登录页面")) + " ")]), _c("div", [_vm._v(_vm._s(_vm.$t("选择账号")))])], 1), _c("div", {
    staticClass: "desBox"
  }, [_vm._v(" " + _vm._s(_vm.$t("检测到手机号")) + " "), _c("span", [_vm._v(_vm._s(_vm.loginInfo.mobile))]), _vm._v(" " + _vm._s(_vm.$t("关联以下"))), _c("span", [_vm._v(_vm._s(_vm.accounts.length))]), _vm._v(_vm._s(_vm.$t("个账号，请选择后进行登录")) + " ")]), _c("div", {
    staticClass: "listBox"
  }, _vm._l(_vm.accounts, function (item, index) {
    return _c("div", {
      key: index,
      on: {
        click: function ($event) {
          return _vm.goIndex(item);
        }
      }
    }, [_c("div", [_c("a-icon", {
      staticStyle: {
        "margin-right": "5px"
      },
      attrs: {
        type: "user"
      }
    }), _vm._v(_vm._s(item.account) + "/" + _vm._s(item.nickName))], 1), _c("a-icon", {
      attrs: {
        type: "arrow-right"
      }
    })], 1);
  }), 0)]), _c("loginErrorModal", {
    attrs: {
      loginErrorVisible: _vm.loginErrorVisible,
      contactWay: _vm.contactWay,
      cancellationTime: _vm.cancellationTime
    },
    on: {
      "update:loginErrorVisible": function ($event) {
        _vm.loginErrorVisible = $event;
      },
      "update:login-error-visible": function ($event) {
        _vm.loginErrorVisible = $event;
      }
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };